/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccountInfo } from '../models/AccountInfo';
import type { AddFinanceToFinPropModel } from '../models/AddFinanceToFinPropModel';
import type { AddressInfo } from '../models/AddressInfo';
import type { AddVehicleToDealModel } from '../models/AddVehicleToDealModel';
import type { AddVehicleToFinPropModel } from '../models/AddVehicleToFinPropModel';
import type { ApplicantAddressType } from '../models/ApplicantAddressType';
import type { ApplicantEmploymentType } from '../models/ApplicantEmploymentType';
import type { ApplyFinanceModel } from '../models/ApplyFinanceModel';
import type { ApplyFinanceProgramRequest } from '../models/ApplyFinanceProgramRequest';
import type { AutoTraderDealMessagesData } from '../models/AutoTraderDealMessagesData';
import type { BaseDealVehicleInfo } from '../models/BaseDealVehicleInfo';
import type { BuildConfigurationDTO } from '../models/BuildConfigurationDTO';
import type { CancelAutoTraderDealRequest } from '../models/CancelAutoTraderDealRequest';
import type { ComparisonFuelModel } from '../models/ComparisonFuelModel';
import type { CreateDealPresentationLinkRequest } from '../models/CreateDealPresentationLinkRequest';
import type { CreateDealPresentationRequest } from '../models/CreateDealPresentationRequest';
import type { CustomerFeedbackModel } from '../models/CustomerFeedbackModel';
import type { CustomerFeedbackSubmitModel } from '../models/CustomerFeedbackSubmitModel';
import type { CustomNewVehicleFilterModel } from '../models/CustomNewVehicleFilterModel';
import type { CustomNewVehicleFilterResultModel } from '../models/CustomNewVehicleFilterResultModel';
import type { DealCDKInfo } from '../models/DealCDKInfo';
import type { DealDataPartialCustomerResponse } from '../models/DealDataPartialCustomerResponse';
import type { DealDataPartialGeneralResponse } from '../models/DealDataPartialGeneralResponse';
import type { DealDataPartialTradeInResponse } from '../models/DealDataPartialTradeInResponse';
import type { DealDataRequest } from '../models/DealDataRequest';
import type { DealDataResponse } from '../models/DealDataResponse';
import type { DealHistoryResponse } from '../models/DealHistoryResponse';
import type { DealOption } from '../models/DealOption';
import type { DealPatchRequest } from '../models/DealPatchRequest';
import type { DealPresentation } from '../models/DealPresentation';
import type { DealProfit } from '../models/DealProfit';
import type { DealsResponse } from '../models/DealsResponse';
import type { DealUploadModel } from '../models/DealUploadModel';
import type { EmploymentInfo } from '../models/EmploymentInfo';
import type { EnquiryCrmRequest } from '../models/EnquiryCrmRequest';
import type { FinanceProposal } from '../models/FinanceProposal';
import type { FinanceProposalData } from '../models/FinanceProposalData';
import type { FinanceProposalOverview } from '../models/FinanceProposalOverview';
import type { FinanceProposalRequestResponse } from '../models/FinanceProposalRequestResponse';
import type { FinanceProposalSaveModel } from '../models/FinanceProposalSaveModel';
import type { FinanceTypeEnum } from '../models/FinanceTypeEnum';
import type { FinPropAddressSaveModel } from '../models/FinPropAddressSaveModel';
import type { FinPropBankSaveModel } from '../models/FinPropBankSaveModel';
import type { FinPropBusinessContactsSaveModel } from '../models/FinPropBusinessContactsSaveModel';
import type { FinPropIndividContactsSaveModel } from '../models/FinPropIndividContactsSaveModel';
import type { FinPropIndividEmploymentSaveModel } from '../models/FinPropIndividEmploymentSaveModel';
import type { FinPropPrintCriterionModel } from '../models/FinPropPrintCriterionModel';
import type { FinPropPrintDataModel } from '../models/FinPropPrintDataModel';
import type { GetFinanceProposalDetailsResponse } from '../models/GetFinanceProposalDetailsResponse';
import type { HandoverArrangementRequest } from '../models/HandoverArrangementRequest';
import type { IndividualInfo } from '../models/IndividualInfo';
import type { InventoryVehicleSearchResultsDealVehicleSearchResponse } from '../models/InventoryVehicleSearchResultsDealVehicleSearchResponse';
import type { LeadDto } from '../models/LeadDto';
import type { NewProposalResponse } from '../models/NewProposalResponse';
import type { OfferCalculateData } from '../models/OfferCalculateData';
import type { PartExchangeInfo } from '../models/PartExchangeInfo';
import type { ProposalResponseModel } from '../models/ProposalResponseModel';
import type { RfvMinModel } from '../models/RfvMinModel';
import type { TelephoneInfo } from '../models/TelephoneInfo';
import type { UpdateDealPresentationLinkRequest } from '../models/UpdateDealPresentationLinkRequest';
import type { UpdateOptionInput } from '../models/UpdateOptionInput';
import type { ValueCarDTO } from '../models/ValueCarDTO';
import type { VehicleFinanceInfo } from '../models/VehicleFinanceInfo';
import type { VehicleTypes } from '../models/VehicleTypes';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DealService {

  /**
   * @param variantId 
   * @param deposit 
   * @param term 
   * @param miles 
   * @param initialRental 
   * @param financeType
 *
 * 1 = HP
 *
 * 2 = PCP
 *
 * 3 = CS0
 *
 * 5 = x4x4
 *
 * 6 = PCPZero
 *
 * 7 = FL
 *
 * 9 = BCH
   * @returns BuildConfigurationDTO Success
   * @throws ApiError
   */
  public static getGetDealConfiguration(
variantId?: number,
deposit?: number,
term?: number,
miles?: number,
initialRental?: number,
financeType?: FinanceTypeEnum,
): CancelablePromise<BuildConfigurationDTO> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetDealConfiguration',
      query: {
        'variantId': variantId,
        'Deposit': deposit,
        'Term': term,
        'Miles': miles,
        'InitialRental': initialRental,
        'FinanceType': financeType,
      },
    });
  }

  /**
   * @param variantId 
   * @param stockId 
   * @param onlyClientShow 
   * @returns DealOption Success
   * @throws ApiError
   */
  public static getGetDealOptions(
variantId?: number,
stockId?: number,
onlyClientShow?: boolean,
): CancelablePromise<Array<DealOption>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetDealOptions',
      query: {
        'variantId': variantId,
        'stockId': stockId,
        'onlyClientShow': onlyClientShow,
      },
    });
  }

  /**
   * @param from 
   * @param to 
   * @param vehicleType
 *
 * 0 = Undefined
 *
 * 1 = Bike (Motorcycle)
 *
 * 2 = Car
 *
 * 3 = Comp (Component vehicle)
 *
 * 4 = Hgv (Heavy Goods Vehicle)
 *
 * 5 = Van (Light Commercial Vehicle)
   * @param managerId 
   * @param contactId 
   * @param customerName 
   * @param status 
   * @param isReserved 
   * @param isNew 
   * @param hasFinanceProposal 
   * @param hasBevQuote 
   * @param branchId 
   * @param dealNo 
   * @param findEnquiry 
   * @param regStockNumber 
   * @param pagingPage 
   * @param pagingPageSize 
   * @returns DealsResponse Success
   * @throws ApiError
   */
  public static getGetDeals(
from: string,
to: string,
vehicleType?: VehicleTypes,
managerId?: number,
contactId?: number,
customerName?: string,
status?: number,
isReserved?: boolean,
isNew?: boolean,
hasFinanceProposal?: boolean,
hasBevQuote?: boolean,
branchId?: number,
dealNo?: number,
findEnquiry?: number,
regStockNumber?: string,
pagingPage?: number,
pagingPageSize?: number,
): CancelablePromise<DealsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetDeals',
      query: {
        'From': from,
        'To': to,
        'VehicleType': vehicleType,
        'ManagerId': managerId,
        'ContactId': contactId,
        'CustomerName': customerName,
        'Status': status,
        'IsReserved': isReserved,
        'IsNew': isNew,
        'HasFinanceProposal': hasFinanceProposal,
        'HasBevQuote': hasBevQuote,
        'BranchId': branchId,
        'DealNo': dealNo,
        'FindEnquiry': findEnquiry,
        'RegStockNumber': regStockNumber,
        'Paging.Page': pagingPage,
        'Paging.PageSize': pagingPageSize,
      },
    });
  }

  /**
   * @param dealId 
   * @param vehicleId 
   * @returns DealDataResponse Success
   * @throws ApiError
   */
  public static getGetDeal(
dealId?: number,
vehicleId?: number,
): CancelablePromise<DealDataResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetDeal',
      query: {
        'dealId': dealId,
        'vehicleId': vehicleId,
      },
    });
  }

  /**
   * @param dealId 
   * @returns ApplyFinanceModel Success
   * @throws ApiError
   */
  public static getGetDealFinanceProposal(
dealId?: number,
): CancelablePromise<ApplyFinanceModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetDealFinanceProposal',
      query: {
        'dealId': dealId,
      },
    });
  }

  /**
   * @param id 
   * @param customerName 
   * @param email 
   * @param phone 
   * @param postcode 
   * @returns LeadDto Success
   * @throws ApiError
   */
  public static getLookUpLead(
id?: number,
customerName?: string,
email?: string,
phone?: string,
postcode?: string,
): CancelablePromise<Array<LeadDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/LookUpLead',
      query: {
        'Id': id,
        'CustomerName': customerName,
        'Email': email,
        'Phone': phone,
        'Postcode': postcode,
      },
    });
  }

  /**
   * @param regNo 
   * @param mileage 
   * @returns ValueCarDTO Success
   * @throws ApiError
   */
  public static getLookUpTradeInVehicle(
regNo?: string,
mileage?: number,
): CancelablePromise<ValueCarDTO> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/LookUpTradeInVehicle',
      query: {
        'regNo': regNo,
        'mileage': mileage,
      },
    });
  }

  /**
   * @param dealId 
   * @param requestBody 
   * @returns BuildConfigurationDTO Success
   * @throws ApiError
   */
  public static postCreatePartExchangeForDeal(
dealId?: number,
requestBody?: PartExchangeInfo,
): CancelablePromise<BuildConfigurationDTO> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CreatePartExchangeForDeal',
      query: {
        'dealId': dealId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param dealId 
   * @returns BuildConfigurationDTO Success
   * @throws ApiError
   */
  public static postRemovePartExchangeForDeal(
dealId?: number,
): CancelablePromise<BuildConfigurationDTO> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/RemovePartExchangeForDeal',
      query: {
        'dealId': dealId,
      },
    });
  }

  /**
   * @param dealId 
   * @returns BuildConfigurationDTO Success
   * @throws ApiError
   */
  public static postRemoveAppraisalForDeal(
dealId?: number,
): CancelablePromise<BuildConfigurationDTO> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/RemoveAppraisalForDeal',
      query: {
        'dealId': dealId,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Created
   * @throws ApiError
   */
  public static postDealCreateEnquiryCrm(
requestBody?: EnquiryCrmRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Deal/CreateEnquiryCRM',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Created
   * @throws ApiError
   */
  public static postCreateDealOffer(
requestBody?: DealDataRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CreateDealOffer',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param enqId 
   * @param userId 
   * @param isShowroom 
   * @returns any Created
   * @throws ApiError
   */
  public static postCreateDealOfferByEnquiry(
enqId?: number,
userId?: number,
isShowroom: boolean = false,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CreateDealOfferByEnquiry',
      query: {
        'enqId': enqId,
        'userId': userId,
        'isShowroom': isShowroom,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Created
   * @throws ApiError
   */
  public static postSaveFinanceApply(
requestBody?: ApplyFinanceModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/SaveFinanceApply',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Created
   * @throws ApiError
   */
  public static postUploadFile(
requestBody?: DealUploadModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/UploadFile',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param saleOfferId 
   * @param documentType 
   * @returns DealDataResponse Success
   * @throws ApiError
   */
  public static getGetUploadedFiles(
saleOfferId?: number,
documentType?: number,
): CancelablePromise<DealDataResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetUploadedFiles',
      query: {
        'saleOfferId': saleOfferId,
        'documentType': documentType,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postAddVehicleToDeal(
requestBody?: AddVehicleToDealModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/AddVehicleToDeal',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param saleOfferVehileId 
   * @returns any Success
   * @throws ApiError
   */
  public static postRemoveVehicleFromDeal(
saleOfferVehileId?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/RemoveVehicleFromDeal',
      query: {
        'saleOfferVehileId': saleOfferVehileId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns CustomNewVehicleFilterResultModel Success
   * @throws ApiError
   */
  public static postSearchCustomVehicleVariants(
requestBody?: CustomNewVehicleFilterModel,
): CancelablePromise<Array<CustomNewVehicleFilterResultModel>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/SearchCustomVehicleVariants',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param dealId 
   * @param requestBody 
   * @returns CustomNewVehicleFilterResultModel Success
   * @throws ApiError
   */
  public static putUpdateDeal(
dealId?: number,
requestBody?: DealPatchRequest,
): CancelablePromise<Array<CustomNewVehicleFilterResultModel>> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/UpdateDeal',
      query: {
        'dealId': dealId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Check registration number for used vehicle
   * @param registrationNumber 
   * @returns any Success
   * @throws ApiError
   */
  public static getDealUsedVehicleCheckRegistrationNumber(
registrationNumber?: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Deal/UsedVehicleCheckRegistrationNumber',
      query: {
        'registrationNumber': registrationNumber,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * Get Finance Proposal side tab with requests info
   * @param dealId 
   * @returns FinanceProposalData Success
   * @throws ApiError
   */
  public static getDealGetFinanceProposalSideBlock(
dealId?: number,
): CancelablePromise<FinanceProposalData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/deal/get-finance-proposal-side-block',
      query: {
        'dealId': dealId,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postUpdateVehicleOption(
requestBody?: UpdateOptionInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/UpdateVehicleOption',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param requestBody 
   * @returns OfferCalculateData Success
   * @throws ApiError
   */
  public static postSaveApplyFinanceProgram(
requestBody?: ApplyFinanceProgramRequest,
): CancelablePromise<OfferCalculateData> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/SaveApplyFinanceProgram',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param dealId 
   * @param userId 
   * @returns any Success
   * @throws ApiError
   */
  public static postDeleteDeal(
dealId?: number,
userId?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/DeleteDeal',
      query: {
        'dealId': dealId,
        'userId': userId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param dealId 
   * @param requestBody 
   * @returns void 
   * @throws ApiError
   */
  public static postSaveApplyHandoverArrangement(
dealId?: number,
requestBody?: HandoverArrangementRequest,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/SaveApplyHandoverArrangement',
      query: {
        'dealId': dealId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postDealSaveProposal(
requestBody?: FinanceProposalSaveModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deal/save-proposal',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postDealSaveProposalApplicants(
requestBody?: FinanceProposalSaveModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deal/save-proposal-applicants',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param proposalId 
   * @param applicantId 
   * @param dealId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static patchDealProposalApplicantUpdateProposalCustomerInformation(
proposalId: number,
applicantId: number,
dealId: string,
requestBody?: IndividualInfo,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/deal/{dealId}/proposal/{proposalId}/applicant/{applicantId}/update-proposal-customer-information',
      path: {
        'proposalId': proposalId,
        'applicantId': applicantId,
        'dealId': dealId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param proposalId 
   * @returns GetFinanceProposalDetailsResponse Success
   * @throws ApiError
   */
  public static getDealsProposal(
proposalId: number,
): CancelablePromise<GetFinanceProposalDetailsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/deals/proposal/{proposalId}',
      path: {
        'proposalId': proposalId,
      },
    });
  }

  /**
   * @param applicantId 
   * @param dealId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static patchDealApplicantUpdateProposalIndividualContacts(
applicantId: number,
dealId: string,
requestBody?: TelephoneInfo,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/deal/{dealId}/applicant/{applicantId}/update-proposal-individual-contacts',
      path: {
        'applicantId': applicantId,
        'dealId': dealId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param applicantId 
   * @param dealId 
   * @param type
 *
 * 1 = CurrentResidential
 *
 * 2 = PreviousResidential
 *
 * 3 = SecondPreviousResidential
 *
 * 4 = CurrentEmployment
 *
 * 5 = PreviousEmployment
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static patchDealApplicantUpdateAddressByType(
applicantId: number,
dealId: string,
type?: ApplicantAddressType,
requestBody?: AddressInfo,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/deal/{dealId}/applicant/{applicantId}/update-address-by-type',
      path: {
        'applicantId': applicantId,
        'dealId': dealId,
      },
      query: {
        'type': type,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param applicantId 
   * @param dealId 
   * @param type
 *
 * 1 = CurrentEmployment
 *
 * 2 = PreviousEmployment
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static patchDealApplicantUpdateEmploymentByType(
applicantId: number,
dealId: string,
type?: ApplicantEmploymentType,
requestBody?: EmploymentInfo,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/deal/{dealId}/applicant/{applicantId}/update-employment-by-type',
      path: {
        'applicantId': applicantId,
        'dealId': dealId,
      },
      query: {
        'type': type,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param applicantId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static patchDealApplicantAccountPrimary(
applicantId: number,
requestBody?: AccountInfo,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/Deal/applicant/{applicantId}/account-primary',
      path: {
        'applicantId': applicantId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postDealSaveProposalIndividualContacts(
requestBody?: FinPropIndividContactsSaveModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deal/save-proposal-individual-contacts',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param saleOfferId 
   * @param customerId 
   * @returns any Success
   * @throws ApiError
   */
  public static postDealSaveSaleOfferCustomerId(
saleOfferId?: number,
customerId?: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deal/save-sale-offer-customer-id',
      query: {
        'saleOfferId': saleOfferId,
        'customerId': customerId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param saleOfferId 
   * @param branchId 
   * @param vehicleId 
   * @returns any Success
   * @throws ApiError
   */
  public static postDealSaveSaleOfferVehicleCdkId(
saleOfferId?: number,
branchId?: number,
vehicleId?: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deal/save-sale-offer-vehicle-cdk-id',
      query: {
        'saleOfferId': saleOfferId,
        'branchId': branchId,
        'vehicleId': vehicleId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param saleOfferId 
   * @param orderId 
   * @returns any Success
   * @throws ApiError
   */
  public static postDealSaveSaleOfferOrderCdkId(
saleOfferId?: number,
orderId?: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deal/save-sale-offer-order-cdk-id',
      query: {
        'saleOfferId': saleOfferId,
        'orderId': orderId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postDealSaveProposalBank(
requestBody?: FinPropBankSaveModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deal/save-proposal-bank',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postDealSaveProposalIndividualEmployment(
requestBody?: FinPropIndividEmploymentSaveModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deal/save-proposal-individual-employment',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postDealSaveProposalAddress(
requestBody?: FinPropAddressSaveModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deal/save-proposal-address',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postDealSaveProposalBusinessContacts(
requestBody?: FinPropBusinessContactsSaveModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deal/save-proposal-business-contacts',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postDealSaveProposalVehicle(
requestBody?: AddVehicleToFinPropModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deal/save-proposal-vehicle',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param methodName 
   * @param typeName 
   * @returns any Success
   * @throws ApiError
   */
  public static postDealGenusProxy(
methodName?: string,
typeName?: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deal/genus/proxy',
      query: {
        'methodName': methodName,
        'typeName': typeName,
      },
    });
  }

  /**
   * @param dealId 
   * @param userId 
   * @returns NewProposalResponse Success
   * @throws ApiError
   */
  public static postDealGenusSubmitFinanceProposal(
dealId?: number,
userId?: number,
): CancelablePromise<NewProposalResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deal/genus/submit-finance-proposal',
      query: {
        'dealId': dealId,
        'userId': userId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param dealId 
   * @param userId 
   * @returns FinanceProposalRequestResponse Success
   * @throws ApiError
   */
  public static postDealCreateFinanceProposalPreview(
dealId?: number,
userId?: number,
): CancelablePromise<FinanceProposalRequestResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deal/create-finance-proposal-preview',
      query: {
        'dealId': dealId,
        'userId': userId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param dealId 
   * @param userId 
   * @returns FinanceProposalOverview Success
   * @throws ApiError
   */
  public static postDealShowFinanceProposalResponse(
dealId?: number,
userId?: number,
): CancelablePromise<FinanceProposalOverview> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deal/show-finance-proposal-response',
      query: {
        'dealId': dealId,
        'userId': userId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param dealId 
   * @param userId 
   * @param sendSubmit 
   * @returns ProposalResponseModel Success
   * @throws ApiError
   */
  public static postDealCreateFinanceProposal(
dealId?: number,
userId?: number,
sendSubmit?: boolean,
): CancelablePromise<ProposalResponseModel> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deal/create-finance-proposal',
      query: {
        'dealId': dealId,
        'userId': userId,
        'sendSubmit': sendSubmit,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param dealId 
   * @param userId 
   * @returns ProposalResponseModel Success
   * @throws ApiError
   */
  public static postDealAmendFinanceProposal(
dealId?: number,
userId?: number,
): CancelablePromise<ProposalResponseModel> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deal/amend-finance-proposal',
      query: {
        'dealId': dealId,
        'userId': userId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param dealId 
   * @param userId 
   * @returns ProposalResponseModel Success
   * @throws ApiError
   */
  public static postDealSubmitFinanceProposal(
dealId?: number,
userId?: number,
): CancelablePromise<ProposalResponseModel> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deal/submit-finance-proposal',
      query: {
        'dealId': dealId,
        'userId': userId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param dealId 
   * @param userId 
   * @returns ProposalResponseModel Success
   * @throws ApiError
   */
  public static postDealStatusFinanceProposal(
dealId?: number,
userId?: number,
): CancelablePromise<ProposalResponseModel> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deal/status-finance-proposal',
      query: {
        'dealId': dealId,
        'userId': userId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postDealSaveProposalFinance(
requestBody?: AddFinanceToFinPropModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deal/save-proposal-finance',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param dealId 
   * @param criteriaId 
   * @returns FinPropPrintDataModel Success
   * @throws ApiError
   */
  public static getGetFinanceProposalPrintData(
dealId?: number,
criteriaId?: number,
): CancelablePromise<Array<FinPropPrintDataModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetFinanceProposalPrintData',
      query: {
        'dealId': dealId,
        'criteriaId': criteriaId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @returns FinPropPrintCriterionModel Success
   * @throws ApiError
   */
  public static getGetFinanceProposalPrintCriterion(): CancelablePromise<Array<FinPropPrintCriterionModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetFinanceProposalPrintCriterion',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param dealId 
   * @param criteriaId 
   * @param userId 
   * @returns ProposalResponseModel Success
   * @throws ApiError
   */
  public static postPrintFinanceProposal(
dealId?: number,
criteriaId?: number,
userId?: number,
): CancelablePromise<ProposalResponseModel> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/PrintFinanceProposal',
      query: {
        'dealId': dealId,
        'criteriaId': criteriaId,
        'userId': userId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns string Success
   * @throws ApiError
   */
  public static getGetPdfFinanceProposal(
id?: number,
): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetPdfFinanceProposal',
      query: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param dealId 
   * @returns void 
   * @throws ApiError
   */
  public static getGenerateProposalVehiclePdf(
dealId?: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GenerateProposalVehiclePdf',
      query: {
        'dealId': dealId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param vehicleId 
   * @param term 
   * @param annualMileage 
   * @param planId 
   * @param lender 
   * @param requestCount 
   * @returns RfvMinModel Success
   * @throws ApiError
   */
  public static getDealsVehiclesLookupRfv(
vehicleId: number,
term?: number,
annualMileage?: number,
planId?: string,
lender?: number,
requestCount?: number,
): CancelablePromise<RfvMinModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/deals/vehicles/{vehicleId}/lookup-rfv',
      path: {
        'vehicleId': vehicleId,
      },
      query: {
        'term': term,
        'annualMileage': annualMileage,
        'planId': planId,
        'lender': lender,
        'requestCount': requestCount,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param dealId 
   * @param userId 
   * @returns DealDataPartialGeneralResponse Success
   * @throws ApiError
   */
  public static postDealsGenusDecision(
dealId?: number,
userId?: number,
): CancelablePromise<DealDataPartialGeneralResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deals/genus/Decision',
      query: {
        'dealId': dealId,
        'userId': userId,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param dealId 
   * @param userId 
   * @returns DealDataPartialGeneralResponse Success
   * @throws ApiError
   */
  public static postDealsGenusESignLink(
dealId?: number,
userId?: number,
): CancelablePromise<DealDataPartialGeneralResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deals/genus/eSignLink',
      query: {
        'dealId': dealId,
        'userId': userId,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param dealId 
   * @param userId 
   * @returns DealDataPartialGeneralResponse Success
   * @throws ApiError
   */
  public static postDealsGenusResetRemoteEsign(
dealId?: number,
userId?: number,
): CancelablePromise<DealDataPartialGeneralResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deals/genus/ResetRemoteEsign',
      query: {
        'dealId': dealId,
        'userId': userId,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param dealId 
   * @param userId 
   * @returns DealDataPartialGeneralResponse Success
   * @throws ApiError
   */
  public static postDealsGenusTriggerRemoteEsign(
dealId?: number,
userId?: number,
): CancelablePromise<DealDataPartialGeneralResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deals/genus/TriggerRemoteEsign',
      query: {
        'dealId': dealId,
        'userId': userId,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param dealId 
   * @param userId 
   * @returns DealDataPartialGeneralResponse Success
   * @throws ApiError
   */
  public static postDealsGenusGenerateDocuments(
dealId?: number,
userId?: number,
): CancelablePromise<DealDataPartialGeneralResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deals/genus/GenerateDocuments',
      query: {
        'dealId': dealId,
        'userId': userId,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param dealId 
   * @param userId 
   * @returns DealDataPartialGeneralResponse Success
   * @throws ApiError
   */
  public static postDealsGenusSendDocuments(
dealId?: number,
userId?: number,
): CancelablePromise<DealDataPartialGeneralResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deals/genus/SendDocuments',
      query: {
        'dealId': dealId,
        'userId': userId,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param dealId 
   * @param userId 
   * @returns DealDataPartialGeneralResponse Success
   * @throws ApiError
   */
  public static postDealsGenusActionRequest(
dealId?: number,
userId?: number,
): CancelablePromise<DealDataPartialGeneralResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deals/genus/ActionRequest',
      query: {
        'dealId': dealId,
        'userId': userId,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @returns FinanceProposal Success
   * @throws ApiError
   */
  public static getDealsAutotraderFinanceProposals(
id: number,
): CancelablePromise<Array<FinanceProposal>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/deals/{id}/autotrader/finance-proposals',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @returns AutoTraderDealMessagesData Success
   * @throws ApiError
   */
  public static getDealsAutotraderMessages(
id: number,
): CancelablePromise<Array<AutoTraderDealMessagesData>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/deals/{id}/autotrader/messages',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postDealsAutotraderMessages(
id: number,
requestBody?: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deals/{id}/autotrader/messages',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static postDealsAutotraderComplete(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deals/{id}/autotrader/complete',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postDealsAutotraderCancel(
id: number,
requestBody?: CancelAutoTraderDealRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deals/{id}/autotrader/cancel',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @returns DealDataPartialGeneralResponse Success
   * @throws ApiError
   */
  public static getDeals(
id: number,
): CancelablePromise<DealDataPartialGeneralResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/deals/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @returns DealDataPartialCustomerResponse Success
   * @throws ApiError
   */
  public static getDealsCustomerInfo(
id: number,
): CancelablePromise<DealDataPartialCustomerResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/deals/{id}/customer-info',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @returns DealDataPartialTradeInResponse Success
   * @throws ApiError
   */
  public static getDealsPartExchange(
id: number,
): CancelablePromise<DealDataPartialTradeInResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/deals/{id}/part-exchange',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @returns DealHistoryResponse Success
   * @throws ApiError
   */
  public static getDealsOfferHistory(
id: number,
): CancelablePromise<Array<DealHistoryResponse>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/deals/{id}/offer-history',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @param historyId 
   * @returns DealHistoryResponse Success
   * @throws ApiError
   */
  public static getDealsOfferHistory1(
id: number,
historyId: number,
): CancelablePromise<Array<DealHistoryResponse>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/deals/{id}/offer-history/{historyId}',
      path: {
        'id': id,
        'historyId': historyId,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @returns BaseDealVehicleInfo Success
   * @throws ApiError
   */
  public static getDealsVehicles(
id: number,
): CancelablePromise<Array<BaseDealVehicleInfo>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/deals/{id}/vehicles',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @param vehicleId 
   * @returns BaseDealVehicleInfo Success
   * @throws ApiError
   */
  public static getDealsVehicles1(
id: number,
vehicleId: number,
): CancelablePromise<BaseDealVehicleInfo> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/deals/{id}/vehicles/{vehicleId}',
      path: {
        'id': id,
        'vehicleId': vehicleId,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @returns BaseDealVehicleInfo Success
   * @throws ApiError
   */
  public static getDealsVehiclesProposal(
id: number,
): CancelablePromise<BaseDealVehicleInfo> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/deals/{id}/vehicles/proposal',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @param annualMileage 
   * @param electricityPrice 
   * @param petrolPrice 
   * @param yearPeriod 
   * @returns ComparisonFuelModel Success
   * @throws ApiError
   */
  public static getDealsVehiclesFuelComparison(
id: number,
annualMileage?: number,
electricityPrice?: number,
petrolPrice?: number,
yearPeriod?: number,
): CancelablePromise<ComparisonFuelModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/deals/{id}/vehicles/fuel-comparison',
      path: {
        'id': id,
      },
      query: {
        'annualMileage': annualMileage,
        'electricityPrice': electricityPrice,
        'petrolPrice': petrolPrice,
        'yearPeriod': yearPeriod,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @param vehicleId 
   * @returns DealOption Success
   * @throws ApiError
   */
  public static getDealsVehiclesOptions(
id: number,
vehicleId: number,
): CancelablePromise<Array<DealOption>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/deals/{id}/vehicles/{vehicleId}/options',
      path: {
        'id': id,
        'vehicleId': vehicleId,
      },
    });
  }

  /**
   * @param id 
   * @param vehicleId 
   * @param blockRfvRequest 
   * @returns VehicleFinanceInfo Success
   * @throws ApiError
   */
  public static getDealsVehiclesFinance(
id: number,
vehicleId: number,
blockRfvRequest: boolean = false,
): CancelablePromise<VehicleFinanceInfo> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/deals/{id}/vehicles/{vehicleId}/finance',
      path: {
        'id': id,
        'vehicleId': vehicleId,
      },
      query: {
        'blockRfvRequest': blockRfvRequest,
      },
    });
  }

  /**
   * @param id 
   * @param vehicleId 
   * @returns DealProfit Success
   * @throws ApiError
   */
  public static getDealsVehiclesProfit(
id: number,
vehicleId: number,
): CancelablePromise<DealProfit> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/deals/{id}/vehicles/{vehicleId}/profit',
      path: {
        'id': id,
        'vehicleId': vehicleId,
      },
    });
  }

  /**
   * @param id 
   * @returns void 
   * @throws ApiError
   */
  public static putDealsVehiclesProposalTmpReservation(
id: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/deals/{id}/vehicles/proposal/tmp-reservation',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns DealCDKInfo Success
   * @throws ApiError
   */
  public static getDealsCdk(
id: number,
): CancelablePromise<DealCDKInfo> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/deals/{id}/cdk',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns void 
   * @throws ApiError
   */
  public static deleteDealsCdkCustomer(
id: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/deals/{id}/cdk/customer',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param dealId 
   * @returns InventoryVehicleSearchResultsDealVehicleSearchResponse Success
   * @throws ApiError
   */
  public static getDealsCdkVehiclesSearch(
dealId: number,
): CancelablePromise<InventoryVehicleSearchResultsDealVehicleSearchResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/deals/{dealId}/cdk/vehicles/search',
      path: {
        'dealId': dealId,
      },
    });
  }

  /**
   * @param id 
   * @returns void 
   * @throws ApiError
   */
  public static deleteDealsCdkVehicle(
id: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/deals/{id}/cdk/vehicle',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns void 
   * @throws ApiError
   */
  public static deleteDealsCdkSaleOrder(
id: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/deals/{id}/cdk/sale-order',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns void 
   * @throws ApiError
   */
  public static putDealsCdkSaleOrderDeliveryDate(
id: number,
requestBody?: string,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/deals/{id}/cdk/sale-order/delivery-date',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns void 
   * @throws ApiError
   */
  public static postDealsCdkSaleOrderConfirm(
id: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deals/{id}/cdk/sale-order/confirm',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns void 
   * @throws ApiError
   */
  public static postDealsCdkSaleOrderCancel(
id: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deals/{id}/cdk/sale-order/cancel',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public static postWebhooksSantanderStatus(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/webhooks/santander/status',
    });
  }

  /**
   * @param isDelete 
   * @returns DealPresentation Success
   * @throws ApiError
   */
  public static getDealsPresentations(
isDelete: boolean = false,
): CancelablePromise<Array<DealPresentation>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/deals/presentations',
      query: {
        'isDelete': isDelete,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postDealsPresentations(
requestBody?: CreateDealPresentationRequest,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deals/presentations',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @param name 
   * @returns void 
   * @throws ApiError
   */
  public static putDealsPresentations(
id: number,
name: string,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/deals/presentations/{Id}',
      path: {
        'Id': id,
      },
      query: {
        'Name': name,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns void 
   * @throws ApiError
   */
  public static deleteDealsPresentations(
id: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/deals/presentations/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns void 
   * @throws ApiError
   */
  public static deleteDealsPresentationsSoft(
id: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/deals/presentations/{id}/soft',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns void 
   * @throws ApiError
   */
  public static postDealsPresentationsRestore(
id: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deals/presentations/{id}/restore',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param presentationId 
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postDealsPresentationsLinks(
presentationId: string,
requestBody?: CreateDealPresentationLinkRequest,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deals/presentations/{PresentationId}/links',
      path: {
        'PresentationId': presentationId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param presentationId 
   * @param id 
   * @param requestBody 
   * @returns void 
   * @throws ApiError
   */
  public static putDealsPresentationsLinks(
presentationId: string,
id: string,
requestBody?: UpdateDealPresentationLinkRequest,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/deals/presentations/{PresentationId}/links/{Id}',
      path: {
        'PresentationId': presentationId,
        'Id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param presentationId 
   * @param id 
   * @returns void 
   * @throws ApiError
   */
  public static deleteDealsPresentationsLinks(
presentationId: number,
id: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/deals/presentations/{presentationId}/links/{id}',
      path: {
        'presentationId': presentationId,
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param formData 
   * @returns string Created
   * @throws ApiError
   */
  public static postDealsPresentationsUploadFile(
formData?: {
file?: Blob;
},
): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deals/presentations/upload-file',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param id 
   * @returns CustomerFeedbackModel Success
   * @throws ApiError
   */
  public static getDealsMarketing(
id: number,
): CancelablePromise<CustomerFeedbackModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/deals/marketing/{id}',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param dealId 
   * @param formData 
   * @returns string Created
   * @throws ApiError
   */
  public static postDealsMarketingSignedPdf(
dealId: number,
formData?: {
file?: Blob;
},
): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/deals/marketing/{dealId}/signed-pdf',
      path: {
        'dealId': dealId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param contactId 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static patchDealsMarketing(
contactId: number,
requestBody?: CustomerFeedbackSubmitModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/deals/marketing/{contactId}',
      path: {
        'contactId': contactId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

}
